module.exports = __webpack_public_path__ + "img/Total.9e2126c8.png";